import { baseApi } from '@alltrails/redux-helpers';
import ConditionsOverlayMetadata from '../types/ConditionsOverlayMetadata';
import TrailConditionOverlayData from '../types/TrailConditionOverlayData';
import TrailConditionOverlayParams from '../types/TrailConditionOverlayParams';
import TrailWeatherOverviewParams from '../types/TrailWeatherOverviewParams';
import TrailWeatherOverviewData from '../types/TrailWeatherOverviewData';
import TrailWeatherConditionsData from '../types/TrailWeatherConditionsData';
import TrailWeatherConditionsParams from '../types/TrailWeatherConditionsParams';
import GroundConditionsOverlayParams from '../types/GroundConditionsOverlayParams';
import GroundConditionsOverlayData from '../types/GroundConditionsOverlayData';

const conditionsApi = baseApi.enhanceEndpoints({}).injectEndpoints({
  endpoints: builder => ({
    getConditionsMetadata: builder.query<ConditionsOverlayMetadata[], void>({
      query: () => {
        return { url: '/api/alltrails/weather-service/v2/overlay/metadata' };
      }
    }),
    getGroundConditionsOverlayData: builder.query<GroundConditionsOverlayData, GroundConditionsOverlayParams>({
      query: ({ trailId, ...params }) => {
        return { url: `/api/alltrails/weather-service/v2/trails/${trailId}/terrain`, config: { params } };
      }
    }),
    getTrailConditionOverlayData: builder.query<TrailConditionOverlayData, TrailConditionOverlayParams>({
      query: ({ trailId, showMore, ...params }) => {
        // If boolean params are false, rtk query is stripping them from the request, so stringify them first to ensure they don't get removed
        const searchParams = { ...params, showMore: String(showMore) };
        return { url: `/api/alltrails/weather-service/v2/trails/${trailId}/overlay`, config: { params: searchParams } };
      }
    }),
    getTrailWeatherConditions: builder.query<TrailWeatherConditionsData, TrailWeatherConditionsParams>({
      query: ({ trailId, ...params }) => {
        return { url: `/api/alltrails/weather-service/v2/trails/${trailId}/conditions`, config: { params } };
      }
    }),
    getTrailWeatherOverview: builder.query<TrailWeatherOverviewData, TrailWeatherOverviewParams>({
      query: ({ trailId, ...params }) => {
        return { url: `/api/alltrails/weather-service/v2/trails/${trailId}/overview`, config: { params } };
      }
    })
  })
});

export const {
  useGetConditionsMetadataQuery,
  useGetGroundConditionsOverlayDataQuery,
  useGetTrailConditionOverlayDataQuery,
  useGetTrailWeatherConditionsQuery,
  useGetTrailWeatherOverviewQuery
} = conditionsApi;
